module.exports = __webpack_public_path__ + "static/media/slide2.b27c2215.png";